import React from 'react'
import { useDispatch,useSelector } from 'react-redux'
import { setPersist } from 'redux/actions/persist'
export default function SearchContainer() {
    const dispatch = useDispatch()
    const persist = useSelector(state => state.persist)
    const onEnter=async (e)=>{
        let {value}=e.target
        if(e.keyCode===13){
            if(value!==''){
                let filter=persist.recent_search.find((d)=>d===value)
                if(filter===undefined){
                    await dispatch(setPersist({recent_search:[value,...persist.recent_search]}))
    
                }
               window.location.assign(`/search?q=${convertHash(value)}`)
            }
           
        }
    }
    const convertHash=(tag)=>{
        let conv=tag.replace('#','%23')
        return conv
    }
    return (
        <div className='search-container'>
            <input onKeyDown={onEnter} autoFocus placeholder="Coba ketik topik atau keyword" className='search-container-field'/>
            <p className='font-nunito font-bold margin-0'>Recent</p>
            <div style={{width:'100%',margin:'10px 0px',height:1,backgroundColor:'#cccccc'}}></div>
            {persist.recent_search.map((data,i)=>{
                if(i<4){
                    return(
                <a key={i} href={`/search?q=${convertHash(data)}`}><p  className='hashtag-item font-nunito'>{data}</p></a>

                    )
                }

            })}
        </div>
    )
}
